export enum RelationStatusMethod {
  OPEN = 'OPEN',

  INPROGRESS = 'INPROGRESS',

  CLOSE = 'CLOSE',
}
